import { Tool } from '@/types/tool';
import { TranslationKey } from '@/translations/translations';

// Real tools data
export const tools: Tool[] = [
  {
    id: 'founder-personality',
    name: 'tools.founderPersonality.name',
    description: 'tools.founderPersonality.description',
    category: 'Assessment',
    status: 'active',
    tags: ['personality', 'assessment', 'founders', 'team', 'psychology'],
    url: 'https://founderpersonality.lovable.app/',
    githubUrl: null, // Private but shared on request
    demoUrl: 'https://founderpersonality.lovable.app/',
    documentation: null,
    license: 'Copyright Kevin Rassner',
    language: ['JavaScript', 'TypeScript'],
    framework: ['React'],
    featured: true,
    createdAt: '2025-11-16',
    updatedAt: '2025-11-16',
    tooltip: {
      title: 'tools.founderPersonality.tooltip.title',
      description: 'tools.founderPersonality.tooltip.description',
      quickStats: {
        lastUpdated: '2025-11-16'
      }
    },
    content: {
      overview: 'tools.founderPersonality.content.overview',

      features: [
        'tools.founderPersonality.content.features.0',
        'tools.founderPersonality.content.features.1',
        'tools.founderPersonality.content.features.2',
        'tools.founderPersonality.content.features.3',
        'tools.founderPersonality.content.features.4'
      ],

      installation: 'tools.founderPersonality.content.installation',

      usage: 'tools.founderPersonality.content.usage',

      examples: [
        'tools.founderPersonality.content.examples.0',
        'tools.founderPersonality.content.examples.1'
      ],

      contribution: 'tools.founderPersonality.content.contribution',

      screenshots: [
        {
          id: 'fp-1',
          title: 'tools.founderPersonality.screenshots.0.title',
          description: 'tools.founderPersonality.screenshots.0.description',
          imageUrl: '/screenshots/founder-personality/founder-personality-1.png',
          caption: 'tools.founderPersonality.screenshots.0.caption'
        },
        {
          id: 'fp-2',
          title: 'tools.founderPersonality.screenshots.1.title',
          description: 'tools.founderPersonality.screenshots.1.description',
          imageUrl: '/screenshots/founder-personality/founder-personality-2.png',
          caption: 'tools.founderPersonality.screenshots.1.caption'
        },
        {
          id: 'fp-3',
          title: 'tools.founderPersonality.screenshots.2.title',
          description: 'tools.founderPersonality.screenshots.2.description',
          imageUrl: '/screenshots/founder-personality/founder-personality-3.png',
          caption: 'tools.founderPersonality.screenshots.2.caption'
        },
        {
          id: 'fp-4',
          title: 'tools.founderPersonality.screenshots.3.title',
          description: 'tools.founderPersonality.screenshots.3.description',
          imageUrl: '/screenshots/founder-personality/founder-personality-4.png',
          caption: 'tools.founderPersonality.screenshots.3.caption'
        },
        {
          id: 'fp-5',
          title: 'tools.founderPersonality.screenshots.4.title',
          description: 'tools.founderPersonality.screenshots.4.description',
          imageUrl: '/screenshots/founder-personality/founder-personality-5.png',
          caption: 'tools.founderPersonality.screenshots.4.caption'
        }
      ]
    }
  },
  {
    id: 'wonder-scribe-kids',
    name: 'tools.wonderScribeKids.name',
    description: 'tools.wonderScribeKids.description',
    category: 'Education',
    status: 'archived',
    tags: ['kids', 'stories', 'AI', 'education', 'interactive', 'children'],
    url: 'https://wonder-scribe-kids.lovable.app/',
    githubUrl: null, // Code available for copying
    demoUrl: 'https://wonder-scribe-kids.lovable.app/',
    documentation: null,
    license: 'MIT',
    language: ['JavaScript', 'TypeScript'],
    framework: ['React'],
    featured: true,
    createdAt: '2025-11-16',
    updatedAt: '2025-11-16',
    tooltip: {
      title: 'tools.wonderScribeKids.tooltip.title',
      description: 'tools.wonderScribeKids.tooltip.description',
      quickStats: {
        lastUpdated: '2025-11-16'
      }
    },
    content: {
      overview: 'tools.wonderScribeKids.content.overview',

      features: [
        'tools.wonderScribeKids.content.features.0',
        'tools.wonderScribeKids.content.features.1',
        'tools.wonderScribeKids.content.features.2',
        'tools.wonderScribeKids.content.features.3',
        'tools.wonderScribeKids.content.features.4',
        'tools.wonderScribeKids.content.features.5',
        'tools.wonderScribeKids.content.features.6',
        'tools.wonderScribeKids.content.features.7'
      ],

      installation: 'tools.wonderScribeKids.content.installation',

      usage: 'tools.wonderScribeKids.content.usage',

      examples: [
        'tools.wonderScribeKids.content.examples.0',
        'tools.wonderScribeKids.content.examples.1'
      ],

      contribution: 'tools.wonderScribeKids.content.contribution',

      screenshots: [
        {
          id: 'wsk-1',
          title: 'tools.wonderScribeKids.screenshots.0.title',
          description: 'tools.wonderScribeKids.screenshots.0.description',
          imageUrl: '/screenshots/wonder-scribe-kids/wonder-scribe-kids-1.png',
          caption: 'tools.wonderScribeKids.screenshots.0.caption'
        },
        {
          id: 'wsk-2',
          title: 'tools.wonderScribeKids.screenshots.1.title',
          description: 'tools.wonderScribeKids.screenshots.1.description',
          imageUrl: '/screenshots/wonder-scribe-kids/wonder-scribe-kids-2.png',
          caption: 'tools.wonderScribeKids.screenshots.1.caption'
        },
        {
          id: 'wsk-3',
          title: 'tools.wonderScribeKids.screenshots.2.title',
          description: 'tools.wonderScribeKids.screenshots.2.description',
          imageUrl: '/screenshots/wonder-scribe-kids/wonder-scribe-kids-3.png',
          caption: 'tools.wonderScribeKids.screenshots.2.caption'
        },
        {
          id: 'wsk-4',
          title: 'tools.wonderScribeKids.screenshots.3.title',
          description: 'tools.wonderScribeKids.screenshots.3.description',
          imageUrl: '/screenshots/wonder-scribe-kids/wonder-scribe-kids-4.png',
          caption: 'tools.wonderScribeKids.screenshots.3.caption'
        }
      ]
    }
  },
  {
    id: 'pitbulls-stats-hub',
    name: 'tools.pitbullsStatsHub.name',
    description: 'tools.pitbullsStatsHub.description',
    category: 'Sports Analytics',
    status: 'active',
    tags: ['sports', 'analytics', 'statistics', 'team', 'development', 'recreational'],
    url: 'https://kevske.github.io/pitbulls-stats-hub/',
    githubUrl: null, // Code available for copying but clean version planned
    demoUrl: 'https://kevske.github.io/pitbulls-stats-hub/',
    documentation: null,
    license: 'MIT',
    language: ['JavaScript', 'HTML', 'CSS'],
    framework: [],
    featured: true,
    createdAt: '2025-11-16',
    updatedAt: '2025-11-16',
    tooltip: {
      title: 'tools.pitbullsStatsHub.tooltip.title',
      description: 'tools.pitbullsStatsHub.tooltip.description',
      quickStats: {
        lastUpdated: '2025-11-16'
      }
    },
    content: {
      overview: 'tools.pitbullsStatsHub.content.overview',

      features: [
        'tools.pitbullsStatsHub.content.features.0',
        'tools.pitbullsStatsHub.content.features.1',
        'tools.pitbullsStatsHub.content.features.2',
        'tools.pitbullsStatsHub.content.features.3',
        'tools.pitbullsStatsHub.content.features.4',
        'tools.pitbullsStatsHub.content.features.5'
      ],

      installation: 'tools.pitbullsStatsHub.content.installation',

      usage: 'tools.pitbullsStatsHub.content.usage',

      examples: [
        'tools.pitbullsStatsHub.content.examples.0',
        'tools.pitbullsStatsHub.content.examples.1',
        'tools.pitbullsStatsHub.content.examples.2'
      ],

      contribution: 'tools.pitbullsStatsHub.content.contribution',

      screenshots: [
        {
          id: 'psh-1',
          title: 'tools.pitbullsStatsHub.screenshots.0.title',
          description: 'tools.pitbullsStatsHub.screenshots.0.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-1.png',
          caption: 'tools.pitbullsStatsHub.screenshots.0.caption'
        },
        {
          id: 'psh-2',
          title: 'tools.pitbullsStatsHub.screenshots.1.title',
          description: 'tools.pitbullsStatsHub.screenshots.1.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-2.png',
          caption: 'tools.pitbullsStatsHub.screenshots.1.caption'
        },
        {
          id: 'psh-3',
          title: 'tools.pitbullsStatsHub.screenshots.2.title',
          description: 'tools.pitbullsStatsHub.screenshots.2.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-3.png',
          caption: 'tools.pitbullsStatsHub.screenshots.2.caption'
        },
        {
          id: 'psh-4',
          title: 'tools.pitbullsStatsHub.screenshots.3.title',
          description: 'tools.pitbullsStatsHub.screenshots.3.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-4.png',
          caption: 'tools.pitbullsStatsHub.screenshots.3.caption'
        },
        {
          id: 'psh-5',
          title: 'tools.pitbullsStatsHub.screenshots.4.title',
          description: 'tools.pitbullsStatsHub.screenshots.4.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-5.png',
          caption: 'tools.pitbullsStatsHub.screenshots.4.caption'
        },
        {
          id: 'psh-6',
          title: 'tools.pitbullsStatsHub.screenshots.5.title',
          description: 'tools.pitbullsStatsHub.screenshots.5.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-6.png',
          caption: 'tools.pitbullsStatsHub.screenshots.5.caption'
        },
        {
          id: 'psh-7',
          title: 'tools.pitbullsStatsHub.screenshots.6.title',
          description: 'tools.pitbullsStatsHub.screenshots.6.description',
          imageUrl: '/screenshots/pitbulls-stats-hub/pitbulls-stats-hub-7.png',
          caption: 'tools.pitbullsStatsHub.screenshots.6.caption'
        }
      ]
    }
  },
  {
    id: 'leadership-roles',
    name: 'tools.leadershipRoles.name',
    description: 'tools.leadershipRoles.description',
    category: 'Assessment & Leadership',
    status: 'active',
    tags: ['leadership', 'assessment', 'agile', 'coaching', 'AI', 'interactive'],
    url: '/tools/leadership_roles',
    githubUrl: null,
    demoUrl: '/tools/leadership_roles',
    documentation: null,
    license: 'Proprietary',
    language: ['TypeScript', 'React'],
    framework: ['Supabase', 'Perplexity API', 'TailwindCSS', 'Motion'],
    featured: true,
    createdAt: '2026-01-15',
    updatedAt: '2026-01-18',
    tooltip: {
      title: 'tools.leadershipRoles.tooltip.title',
      description: 'tools.leadershipRoles.tooltip.description',
      quickStats: {
        lastUpdated: '2026-01-18'
      }
    },
    content: {
      overview: 'tools.leadershipRoles.content.overview',
      features: [
        'tools.leadershipRoles.content.features.0',
        'tools.leadershipRoles.content.features.1',
        'tools.leadershipRoles.content.features.2',
        'tools.leadershipRoles.content.features.3',
        'tools.leadershipRoles.content.features.4'
      ],
      installation: 'tools.leadershipRoles.content.installation',
      usage: 'tools.leadershipRoles.content.usage',
      examples: [
        'tools.leadershipRoles.content.examples.0',
        'tools.leadershipRoles.content.examples.1'
      ],
      contribution: 'tools.leadershipRoles.content.contribution',
      screenshots: [
        {
          id: 'acct-1',
          title: 'tools.leadershipRoles.screenshots.0.title',
          description: 'tools.leadershipRoles.screenshots.0.description',
          imageUrl: '/screenshots/agile-coach-competence/agile-coach-competence_1.png',
          caption: 'tools.leadershipRoles.screenshots.0.caption'
        },
        {
          id: 'acct-2',
          title: 'tools.leadershipRoles.screenshots.1.title',
          description: 'tools.leadershipRoles.screenshots.1.description',
          imageUrl: '/screenshots/agile-coach-competence/agile-coach-competence_2.png',
          caption: 'tools.leadershipRoles.screenshots.1.caption'
        },
        {
          id: 'acct-3',
          title: 'tools.leadershipRoles.screenshots.2.title',
          description: 'tools.leadershipRoles.screenshots.2.description',
          imageUrl: '/screenshots/agile-coach-competence/agile-coach-competence_3.png',
          caption: 'tools.leadershipRoles.screenshots.2.caption'
        },
        {
          id: 'acct-4',
          title: 'tools.leadershipRoles.screenshots.3.title',
          description: 'tools.leadershipRoles.screenshots.3.description',
          imageUrl: '/screenshots/agile-coach-competence/agile-coach-competence_4.png',
          caption: 'tools.leadershipRoles.screenshots.3.caption'
        }
      ]
    }
  },

  {
    id: 'ai-tool-evaluation-prompt-generator',
    name: 'tools.aiToolEvaluationPromptGenerator.name',
    description: 'tools.aiToolEvaluationPromptGenerator.description',
    category: 'Productivity Tools',
    status: 'active',
    tags: ['AI', 'evaluation', 'prompts', 'startup', 'business', 'tools'],
    url: '/tools/ai-tool-evaluation-prompt-generator',
    githubUrl: null,
    demoUrl: '/tools/ai-tool-evaluation-prompt-generator',
    documentation: null,
    license: 'MIT',
    language: ['JavaScript', 'HTML', 'CSS'],
    framework: [],
    featured: true,
    createdAt: '2025-11-17',
    updatedAt: '2025-11-17',
    tooltip: {
      title: 'tools.aiToolEvaluationPromptGenerator.tooltip.title',
      description: 'tools.aiToolEvaluationPromptGenerator.tooltip.description',
      quickStats: {
        lastUpdated: '2025-11-17'
      }
    },
    content: {
      overview: 'tools.aiToolEvaluationPromptGenerator.content.overview',
      features: [
        'tools.aiToolEvaluationPromptGenerator.content.features.0',
        'tools.aiToolEvaluationPromptGenerator.content.features.1',
        'tools.aiToolEvaluationPromptGenerator.content.features.2',
        'tools.aiToolEvaluationPromptGenerator.content.features.3',
        'tools.aiToolEvaluationPromptGenerator.content.features.4',
        'tools.aiToolEvaluationPromptGenerator.content.features.5',
        'tools.aiToolEvaluationPromptGenerator.content.features.6'
      ],
      installation: 'tools.aiToolEvaluationPromptGenerator.content.installation',
      usage: 'tools.aiToolEvaluationPromptGenerator.content.usage',
      examples: [
        'tools.aiToolEvaluationPromptGenerator.content.examples.0',
        'tools.aiToolEvaluationPromptGenerator.content.examples.1',
        'tools.aiToolEvaluationPromptGenerator.content.examples.2'
      ],
      contribution: 'tools.aiToolEvaluationPromptGenerator.content.contribution',
      screenshots: [
        {
          id: 'aiepg-1',
          title: 'tools.aiToolEvaluationPromptGenerator.screenshots.0.title',
          description: 'tools.aiToolEvaluationPromptGenerator.screenshots.0.description',
          imageUrl: '/screenshots/ai-tool-evaluation-prompt-generator/ai-tool-evaluation-prompt-generator-1.png',
          caption: 'tools.aiToolEvaluationPromptGenerator.screenshots.0.caption'
        },
        {
          id: 'aiepg-2',
          title: 'tools.aiToolEvaluationPromptGenerator.screenshots.1.title',
          description: 'tools.aiToolEvaluationPromptGenerator.screenshots.1.description',
          imageUrl: '/screenshots/ai-tool-evaluation-prompt-generator/ai-tool-evaluation-prompt-generator-2.png',
          caption: 'tools.aiToolEvaluationPromptGenerator.screenshots.1.caption'
        },
        {
          id: 'aiepg-3',
          title: 'tools.aiToolEvaluationPromptGenerator.screenshots.2.title',
          description: 'tools.aiToolEvaluationPromptGenerator.screenshots.2.description',
          imageUrl: '/screenshots/ai-tool-evaluation-prompt-generator/ai-tool-evaluation-prompt-generator-3.png',
          caption: 'tools.aiToolEvaluationPromptGenerator.screenshots.2.caption'
        }
      ]
    }
  },
  {
    id: 'wordclock-esp8266',
    name: 'tools.wordClockEsp8266.name',
    description: 'tools.wordClockEsp8266.description',
    category: 'IoT & Hardware',
    status: 'active',
    tags: ['ESP8266', 'IoT', 'hardware', 'clock', 'personalized', 'family', 'home-automation'],
    url: 'https://github.com/kevske/wordclock_esp8266',
    githubUrl: 'https://github.com/kevske/wordclock_esp8266',
    demoUrl: null,
    documentation: null,
    license: 'MIT',
    language: ['C++', 'Arduino'],
    framework: ['ESP8266', 'Arduino'],
    featured: true,
    createdAt: '2025-11-17',
    updatedAt: '2025-11-17',
    tooltip: {
      title: 'tools.wordClockEsp8266.tooltip.title',
      description: 'tools.wordClockEsp8266.tooltip.description',
      quickStats: {
        lastUpdated: '2025-11-17'
      }
    },
    content: {
      overview: 'tools.wordClockEsp8266.content.overview',
      features: [
        'tools.wordClockEsp8266.content.features.0',
        'tools.wordClockEsp8266.content.features.1',
        'tools.wordClockEsp8266.content.features.2',
        'tools.wordClockEsp8266.content.features.3',
        'tools.wordClockEsp8266.content.features.4',
        'tools.wordClockEsp8266.content.features.5',
        'tools.wordClockEsp8266.content.features.6'
      ],
      installation: 'tools.wordClockEsp8266.content.installation',
      usage: 'tools.wordClockEsp8266.content.usage',
      examples: [
        'tools.wordClockEsp8266.content.examples.0',
        'tools.wordClockEsp8266.content.examples.1',
        'tools.wordClockEsp8266.content.examples.2'
      ],
      contribution: 'tools.wordClockEsp8266.content.contribution',
      screenshots: [
        {
          id: 'wc-1',
          title: 'tools.wordClockEsp8266.screenshots.0.title',
          description: 'tools.wordClockEsp8266.screenshots.0.description',
          imageUrl: '/screenshots/wordclock-esp8266/wordclock-esp-1.jpg',
          caption: 'tools.wordClockEsp8266.screenshots.0.caption'
        },
        {
          id: 'wc-2',
          title: 'tools.wordClockEsp8266.screenshots.1.title',
          description: 'tools.wordClockEsp8266.screenshots.1.description',
          imageUrl: '/screenshots/wordclock-esp8266/wordclock-esp-2.jpg',
          caption: 'tools.wordClockEsp8266.screenshots.1.caption'
        },
        {
          id: 'wc-3',
          title: 'tools.wordClockEsp8266.screenshots.2.title',
          description: 'tools.wordClockEsp8266.screenshots.2.description',
          imageUrl: '/screenshots/wordclock-esp8266/wordclock-esp-3.jpg',
          caption: 'tools.wordClockEsp8266.screenshots.2.caption'
        }
      ]
    }
  },
  {
    id: 'od-ontology',
    name: 'tools.odOntology.name',
    description: 'tools.odOntology.description',
    category: 'Research Tools',
    status: 'archived',
    tags: ['Organizational Behavior', 'database', 'ontology', 'research', 'analysis'],
    url: 'https://github.com/kevske/OD_ontology',
    githubUrl: 'https://github.com/kevske/OD_ontology',
    demoUrl: null,
    documentation: null,
    license: 'MIT',
    language: ['JavaScript'],
    framework: ['Supabase'],
    featured: true,
    createdAt: '2025-12-22',
    updatedAt: '2025-12-22',
    tooltip: {
      title: 'tools.odOntology.tooltip.title',
      description: 'tools.odOntology.tooltip.description',
      quickStats: {
        lastUpdated: '2025-12-22'
      }
    },
    content: {
      overview: 'tools.odOntology.content.overview',

      features: [
        'tools.odOntology.content.features.0',
        'tools.odOntology.content.features.1',
        'tools.odOntology.content.features.2'
      ],

      installation: 'tools.odOntology.content.installation',

      usage: 'tools.odOntology.content.usage',

      examples: [
        'tools.odOntology.content.examples.0',
        'tools.odOntology.content.examples.1'
      ],

      contribution: 'tools.odOntology.content.contribution',

      screenshots: [
        {
          id: 'odo-1',
          title: 'tools.odOntology.screenshots.0.title',
          description: 'tools.odOntology.screenshots.0.description',
          imageUrl: '/screenshots/od-ontology/od-ontology-1.png',
          caption: 'tools.odOntology.screenshots.0.caption'
        },
        {
          id: 'odo-2',
          title: 'tools.odOntology.screenshots.1.title',
          description: 'tools.odOntology.screenshots.1.description',
          imageUrl: '/screenshots/od-ontology/od-ontology-2.png',
          caption: 'tools.odOntology.screenshots.1.caption'
        },
        {
          id: 'odo-3',
          title: 'tools.odOntology.screenshots.2.title',
          description: 'tools.odOntology.screenshots.2.description',
          imageUrl: '/screenshots/od-ontology/od-ontology-3.png',
          caption: 'tools.odOntology.screenshots.2.caption'
        },
        {
          id: 'odo-4',
          title: 'tools.odOntology.screenshots.3.title',
          description: 'tools.odOntology.screenshots.3.description',
          imageUrl: '/screenshots/od-ontology/od-ontology-4.png',
          caption: 'tools.odOntology.screenshots.3.caption'
        },
        {
          id: 'odo-5',
          title: 'tools.odOntology.screenshots.4.title',
          description: 'tools.odOntology.screenshots.4.description',
          imageUrl: '/screenshots/od-ontology/od-ontology-5.png',
          caption: 'tools.odOntology.screenshots.4.caption'
        }
      ]
    }
  },
  {
    id: 'expertier1',
    name: 'tools.expertier1.name',
    description: 'tools.expertier1.description',
    category: 'Platform',
    status: 'archived',
    tags: ['marketplace', 'consultants', 'platform', 'matching', 'React', 'Supabase', 'enterprise'],
    url: null,
    githubUrl: null,
    demoUrl: null,
    documentation: null,
    license: 'Proprietary',
    language: ['TypeScript', 'JavaScript'],
    framework: ['React', 'Vite', 'Supabase', 'TailwindCSS'],
    featured: true,
    createdAt: '2025-12-01',
    updatedAt: '2026-01-01',
    tooltip: {
      title: 'tools.expertier1.tooltip.title',
      description: 'tools.expertier1.tooltip.description',
      quickStats: {
        lastUpdated: '2026-01-01'
      }
    },
    content: {
      overview: 'tools.expertier1.content.overview',

      features: [
        'tools.expertier1.content.features.0',
        'tools.expertier1.content.features.1',
        'tools.expertier1.content.features.2',
        'tools.expertier1.content.features.3',
        'tools.expertier1.content.features.4',
        'tools.expertier1.content.features.5',
        'tools.expertier1.content.features.6',
        'tools.expertier1.content.features.7'
      ],

      installation: 'tools.expertier1.content.installation',

      usage: 'tools.expertier1.content.usage',

      examples: [
        'tools.expertier1.content.examples.0',
        'tools.expertier1.content.examples.1',
        'tools.expertier1.content.examples.2'
      ],

      contribution: 'tools.expertier1.content.contribution',

      screenshots: [
        {
          id: 'exp1-1',
          title: 'tools.expertier1.screenshots.0.title',
          description: 'tools.expertier1.screenshots.0.description',
          imageUrl: '/screenshots/expertier1/Expertier1 - 7_Consultant_Page.png',
          caption: 'tools.expertier1.screenshots.0.caption'
        },
        {
          id: 'exp1-2',
          title: 'tools.expertier1.screenshots.1.title',
          description: 'tools.expertier1.screenshots.1.description',
          imageUrl: '/screenshots/expertier1/Expertier1 - 8_Consultant_Dashboard.png',
          caption: 'tools.expertier1.screenshots.1.caption'
        },
        {
          id: 'exp1-3',
          title: 'tools.expertier1.screenshots.2.title',
          description: 'tools.expertier1.screenshots.2.description',
          imageUrl: '/screenshots/expertier1/Expertier1 - 4_Company_Page.png',
          caption: 'tools.expertier1.screenshots.2.caption'
        },
        {
          id: 'exp1-4',
          title: 'tools.expertier1.screenshots.3.title',
          description: 'tools.expertier1.screenshots.3.description',
          imageUrl: '/screenshots/expertier1/Expertier1 - 6_Company_Dashboard.png',
          caption: 'tools.expertier1.screenshots.3.caption'
        },
        {
          id: 'exp1-5',
          title: 'tools.expertier1.screenshots.4.title',
          description: 'tools.expertier1.screenshots.4.description',
          imageUrl: '/screenshots/expertier1/Expertier1 - 5_Company_Claim.png',
          caption: 'tools.expertier1.screenshots.4.caption'
        }
      ]
    }
  }
];
